<template>
    <div class="section dots" ref="dots">
        <span v-for="i in dots" :key="i" :style="gapStyle(i)"></span>
    </div>
</template>

<script>
export default {
    name: 'DashedLine',
    props: {
        num: {
            type: Number,
            default: 1,
        },
    },
    data() {
        return {
            dots: 18,
            gap: 10,
        };
    },
    mounted() {
        this.$nextTick(() => {
            this.getDotsCount();
        });
    },
    methods: {
        getDotsCount() {
            const element = this.$refs.dots;
            this.dots = Math.floor((element.offsetWidth - 20) / this.gap);
        },
        gapStyle(i) {
            return { left: i * this.gap + this.gap + 'px' };
        },
    },
};
</script>

<style lang="scss" scoped>
.section {
    position: relative;
    width: 100%;
    display: block;
    z-index: 2;
    span {
        position: absolute;
        width: 6px;
        height: 6px;
        display: block;
        border-radius: 50%;
        top: 0;
        z-index: 3;
        background: #f8f8f8;
        transform: translateY(-50%);
    }
}
</style>